import React from "react"
import PropTypes from "prop-types"
import styles from "./Footer.module.scss"
import { useStaticQuery, graphql } from "gatsby"
import BlockContentWrapper from "../blockContent"
import LinkButton from "../linkButton"

const Footer = ({ siteName, navigationLinks }) => {
  const response = useStaticQuery(graphql`
    query {
      sanityFooter(_id: { regex: "/footer$/" }) {
        title
        employees {
          phone
          position
          name
          email
        }
        _rawContactInformation
        socialLinks {
          href
          name
        }
      }
    }
  `)

  const {
    title,
    employees,
    _rawContactInformation: contactInformation,
    socialLinks,
  } = response.sanityFooter

  return (
    <footer className={styles.footer}>
      <h2>{title}</h2>
      <div className={styles.wrapper}>
        <div className={styles.employees}>
          {employees.map((employee, index) => (
            <div className={styles.employee} key={`'employee-${index}`}>
              <p>{employee.name}</p>
              <p>{employee.position}</p>
              <p>{employee.phone}</p>
              <p>{employee.email}</p>
            </div>
          ))}
        </div>
        <div className={styles.companyInformaiton}>
          <div className={styles.companyContactInformation}>
            <BlockContentWrapper blocks={contactInformation} />
          </div>
          <div className={styles.socialLinks}>
            {socialLinks.map((link, index) => (
              <LinkButton
                href={link.href}
                target="_blank"
                key={`link-${index}`}
              >
                {link.name}
              </LinkButton>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  siteName: PropTypes.string,
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ),
}

export default Footer
